<template>
    <div class="topBar" v-if="showTopBar">
        <p>BETA</p>
    </div>
</template>

<script src="./TopBar.js"></script>
